import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useSetKeepInTouchMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (keepInTouches: Api.IKeepInTouch[]) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (keepInTouches: Api.IKeepInTouch[]) => {
			return userSession.webServiceHelper.callAsync<Api.IKeepInTouch[]>(`keepintouch/multiple`, 'POST', keepInTouches);
		},
		onSuccess,
		onError,
	});
}
